import { ObjectId } from './ObjectId'

const nullObjectIdString = '000000000000000000000000'
export const nullObjectId = new ObjectId(nullObjectIdString)

export const isNullObjectId = (id: string | ObjectId) => {
    return id.toString() === nullObjectIdString
}
